module.exports = __webpack_public_path__ + "img/refresh2.af307040.png";